<div class="p-3">
  <div class="row">
    <div *bitfUiRoleManager="{ action: eRoleActions.EDIT_ITEM }" class="col-24 col-sm-12">
      <mpa-file-uploader
        (startUpload)="onUpload()"
        [fileUploaderConfig]="{ maxFileSize: 26214400, concatenateMultipleFiles: true }"
      >
      </mpa-file-uploader>
    </div>

    <div
      [ngClass]="uiRoleManagerService.canI(eRoleActions.EDIT_ITEM) ? 'col-24 col-sm-12' : 'col'"
      class="mt-4 mt-sm-0 border-left"
    >
      @if (selectedItem?.files?.length) {
        <h4>{{ 'COMMON.LABEL.FILES' | translate }}</h4>
        <div class="files-list">
          @for (file of filesList; track trackByFileId(i, file); let i = $index) {
            <div class="item-container border-bottom d-flex justify-content-between py-2 w-100">
              <div class="item-details d-flex align-items-center flex-shrink-1">
                <div class="file-preview-container border border-rounded mr-3">
                  @if (file.isImage) {
                    <img class="file-preview" [src]="file.thumbnailUrl" [alt]="file.name" loading="lazy" />
                  } @else {
                    <div class="file-type-icon text-muted">
                      <mat-icon>{{ getFileTypeIcon(file) }}</mat-icon>
                      <span>{{ file.fileExtension }}</span>
                    </div>
                  }
                </div>
                <div class="item-name">
                  {{ file.name }}
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-end">
                <button mat-icon-button color="primary" [matMenuTriggerFor]="fileMenu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #fileMenu="matMenu">
                  <a mat-menu-item [href]="file.url" target="_blank" rel="noopener">
                    <mat-icon>open_in_new</mat-icon>
                    <span>{{ 'COMMON.LABEL.OPEN_LINK' | translate }}</span>
                  </a>
                  <button mat-menu-item (click)="onDownloadFile(file)">
                    <mat-icon>download</mat-icon>
                    <span>{{ 'COMMON.LABEL.DOWNLOAD' | translate }}</span>
                  </button>
                  @if (uiRoleManagerService.canI(eRoleActions.EDIT_ITEM)) {
                    <button mat-menu-item class="danger-menu-item" (click)="onRemoveFile(file)">
                      <mat-icon color="warn">delete</mat-icon>
                      <span>{{ 'COMMON.LABEL.DELETE' | translate }}</span>
                    </button>
                  }
                </mat-menu>
              </div>
            </div>
          }
        </div>
      }

      @if (!selectedItem?.files?.length) {
        <h4>{{ 'ITEM.DETAIL.EMPTY_ITEM_FILES' | translate }}</h4>
      }
    </div>
  </div>
</div>
